(function () {
  const PROMO_ID = 'dia_marina_2026';
  const FREE_GIFT_KEY = '_free_gift';
  const GIFT_PROMO_KEY = '_gift_promo';

  let requestInFlight = false;
  let queuedRefresh = false;

  function money(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }

    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'MXN'
    }).format(cents / 100);
  }

  function isActive(root) {
    const start = Date.parse(root.dataset.start);
    const end = Date.parse(root.dataset.end);
    const now = Date.now();

    if (!Number.isNaN(start) && now < start) return false;
    if (!Number.isNaN(end) && now > end) return false;

    return true;
  }

  function getGiftVariantIds(root) {
    return (root.dataset.giftVariantIds || '')
      .split(',')
      .map((id) => id.trim())
      .filter(Boolean);
  }

  function hasGiftProperties(item) {
    const properties = item.properties || {};
    const freeGift = properties[FREE_GIFT_KEY];
    const promoId = properties[GIFT_PROMO_KEY];

    return (freeGift === true || freeGift === 'true') && promoId === PROMO_ID;
  }

  function getEligibleSubtotal(cart) {
    return cart.items.reduce((total, item) => {
      if (hasGiftProperties(item)) return total;
      return total + item.final_line_price;
    }, 0);
  }

  function getGiftLines(cart) {
    return cart.items.filter(hasGiftProperties);
  }

  function getSectionsToRender() {
    const sections = [];
    const miniCart = document.getElementById('mini-cart');
    const mainCart = document.getElementById('main-cart');
    const mainCartSummary = document.getElementById('main-cart-summary');

    if (miniCart) sections.push('mini-cart');
    if (mainCart && mainCart.dataset.id) sections.push(mainCart.dataset.id);
    if (mainCartSummary && mainCartSummary.dataset.id && !sections.includes(mainCartSummary.dataset.id)) {
      sections.push(mainCartSummary.dataset.id);
    }

    return sections;
  }

  function updateHeaderCount(count) {
    const drawerCount = document.querySelector('#cartDrawer-count');
    const headerCount = document.querySelector('[data-header-cart-count]');

    if (drawerCount) drawerCount.textContent = `(${count})`;

    if (!headerCount) return;

    if (count === 0) {
      headerCount.classList.add('hidden');
      return;
    }

    headerCount.classList.remove('hidden');
    headerCount.textContent = count < 100 ? count : '';
  }

  function getSectionInnerHTML(html, selector) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const element = parsed.querySelector(selector);
    return element ? element.innerHTML : '';
  }

  function renderSections(state) {
    if (!state || !state.sections) return;

    if (state.sections['mini-cart']) {
      const drawer = document.querySelector('cart-drawer');
      const drawerHTML = getSectionInnerHTML(state.sections['mini-cart'], 'cart-drawer');

      if (drawer && drawerHTML) {
        drawer.innerHTML = drawerHTML;
      }
    }

    const mainCart = document.getElementById('main-cart');
    const mainCartSummary = document.getElementById('main-cart-summary');
    const mainSectionId = mainCart && mainCart.dataset.id;

    if (mainSectionId && state.sections[mainSectionId]) {
      const cartContentHTML = getSectionInnerHTML(state.sections[mainSectionId], '.cart-content');
      const summaryHTML = getSectionInnerHTML(state.sections[mainSectionId], '.cart-summary-inner');

      if (cartContentHTML) {
        const target = document.querySelector('.cart-content');
        if (target) target.innerHTML = cartContentHTML;
      }

      if (summaryHTML && mainCartSummary) {
        const target = mainCartSummary.querySelector('.cart-summary-inner');
        if (target) target.innerHTML = summaryHTML;
      }
    }

    if (state.item_count !== undefined) updateHeaderCount(state.item_count);
    if (state.total_price !== undefined && typeof shippingProgressBar === 'function') {
      shippingProgressBar(state.total_price);
    }

    initRoots();
  }

  async function renderCartFromSections() {
    const renderPromises = [];

    if (document.getElementById('mini-cart')) {
      renderPromises.push(
        fetch('/?section_id=mini-cart')
          .then((response) => response.text())
          .then((html) => {
            const drawer = document.querySelector('cart-drawer');
            const drawerHTML = getSectionInnerHTML(html, 'cart-drawer');

            if (drawer && drawerHTML) {
              drawer.innerHTML = drawerHTML;
            }
          })
      );
    }

    const mainCart = document.getElementById('main-cart');
    const mainCartSummary = document.getElementById('main-cart-summary');

    if (mainCart && mainCart.dataset.id) {
      renderPromises.push(
        fetch(`${window.location.pathname}?section_id=${mainCart.dataset.id}`)
          .then((response) => response.text())
          .then((html) => {
            const cartContentHTML = getSectionInnerHTML(html, '.cart-content');
            const summaryHTML = getSectionInnerHTML(html, '.cart-summary-inner');
            const cartTarget = document.querySelector('.cart-content');
            const summaryTarget = mainCartSummary && mainCartSummary.querySelector('.cart-summary-inner');

            if (cartTarget && cartContentHTML) cartTarget.innerHTML = cartContentHTML;
            if (summaryTarget && summaryHTML) summaryTarget.innerHTML = summaryHTML;
          })
      );
    }

    await Promise.all(renderPromises);
    initRoots();
  }

  async function fetchCart() {
    const response = await fetch('/cart.js');
    if (!response.ok) throw new Error('Cart request failed');
    return response.json();
  }

  async function changeLine(id, quantity) {
    const body = {
      id,
      quantity,
      sections: getSectionsToRender(),
      sections_url: window.location.pathname
    };

    const response = await fetch('/cart/change.js', {
      ...fetchConfig(),
      body: JSON.stringify(body)
    });

    if (!response.ok) throw new Error('Cart change failed');
    return response.json();
  }

  async function addGiftVariant(variantId) {
    const body = {
      items: [
        {
          id: Number(variantId),
          quantity: 1,
          properties: {
            [FREE_GIFT_KEY]: 'true',
            [GIFT_PROMO_KEY]: PROMO_ID
          }
        }
      ],
      sections: getSectionsToRender(),
      sections_url: window.location.pathname
    };

    const response = await fetch('/cart/add.js', {
      ...fetchConfig(),
      body: JSON.stringify(body)
    });

    const state = await response.json();

    if (!response.ok || state.status) {
      throw new Error(state.description || state.message || 'No se pudo agregar la gorra.');
    }

    return state;
  }

  async function removeGiftLines(lines) {
    let state = null;

    for (const line of lines) {
      state = await changeLine(line.key, 0);
    }

    return state;
  }

  async function normalizeGiftLines(root, cart) {
    const giftLines = getGiftLines(cart);
    const allowedVariantIds = getGiftVariantIds(root);
    const invalidGiftLines = giftLines.filter((line) => !allowedVariantIds.includes(String(line.variant_id)));
    const threshold = Number(root.dataset.threshold || 150000);
    const eligibleSubtotal = getEligibleSubtotal(cart);

    if (invalidGiftLines.length > 0) {
      return removeGiftLines(invalidGiftLines);
    }

    if (!isActive(root) || eligibleSubtotal < threshold) {
      if (giftLines.length > 0) return removeGiftLines(giftLines);
      return null;
    }

    if (giftLines.length > 1) {
      return removeGiftLines(giftLines.slice(1));
    }

    if (giftLines.length === 1 && giftLines[0].quantity > 1) {
      return changeLine(giftLines[0].key, 1);
    }

    return null;
  }

  function setCardState(card) {
    const selector = card.querySelector('[data-dia-marina-variant-select]');
    const button = card.querySelector('[data-dia-marina-add]');
    const image = card.querySelector('[data-dia-marina-image]');
    const selectedOption = selector && selector.options ? selector.options[selector.selectedIndex] : selector;
    const available = selectedOption && selectedOption.dataset.available === 'true';
    const imageUrl = selectedOption && selectedOption.dataset.image;

    if (image && imageUrl) image.src = imageUrl;
    if (!button) return;

    button.disabled = !available;
    button.querySelector('[data-dia-marina-button-text]').textContent = available ? 'Agregar esta gorra' : 'No disponible';
  }

  function setSelectedGift(root, cart) {
    const selected = getGiftLines(cart)[0];
    const selectedVariantId = selected ? String(selected.variant_id) : '';

    root.classList.toggle('is-selected', Boolean(selectedVariantId));

    root.querySelectorAll('[data-dia-marina-add]').forEach((button) => {
      const card = button.closest('[data-dia-marina-card]');
      const selector = card && card.querySelector('[data-dia-marina-variant-select]');
      const currentVariantId = selector && selector.value;
      const isSelected = currentVariantId === selectedVariantId;

      button.dataset.diaMarinaSelected = isSelected ? 'true' : 'false';

      if (!button.disabled) {
        button.querySelector('[data-dia-marina-button-text]').textContent = isSelected ? 'Gorra elegida' : 'Agregar esta gorra';
      }
    });
  }

  function updateRoot(root, cart) {
    const threshold = Number(root.dataset.threshold || 150000);
    const eligibleSubtotal = getEligibleSubtotal(cart);
    const remaining = Math.max(threshold - eligibleSubtotal, 0);
    const progress = Math.min(Math.round((eligibleSubtotal / threshold) * 100), 100);
    const unlocked = isActive(root) && eligibleSubtotal >= threshold;
    const message = root.querySelector('[data-dia-marina-message]');
    const progressBar = root.querySelector('[data-dia-marina-progress]');
    const selector = root.querySelector('[data-dia-marina-selector]');

    root.classList.toggle('is-locked', !unlocked);
    if (progressBar) progressBar.style.width = `${progress}%`;

    if (!isActive(root)) {
      if (message) message.textContent = 'Esta promoción ya no está vigente.';
      if (selector) selector.hidden = true;
      return;
    }

    if (message) {
      message.textContent = unlocked
        ? '¡Gorra gratis desbloqueada! Elige tu gorra participante.'
        : `Te faltan ${money(remaining)} para desbloquear tu gorra gratis.`;
    }

    if (selector) selector.hidden = !unlocked;
    setSelectedGift(root, cart);
  }

  async function refresh(enforce = true) {
    if (requestInFlight) {
      queuedRefresh = true;
      return;
    }

    requestInFlight = true;

    try {
      const roots = getRoots();
      if (!roots.length) return;

      const cart = await fetchCart();
      updateHeaderCount(cart.item_count);
      const state = enforce ? await normalizeGiftLines(roots[0], cart) : null;

      if (state) {
        renderSections(state);
        const updatedCart = await fetchCart();
        updateHeaderCount(updatedCart.item_count);
        getRoots().forEach((root) => updateRoot(root, updatedCart));
      } else {
        roots.forEach((root) => updateRoot(root, cart));
      }
    } catch (error) {
      console.error(error);
    } finally {
      requestInFlight = false;
      if (queuedRefresh) {
        queuedRefresh = false;
        refresh(enforce);
      }
    }
  }

  async function onAddClick(event) {
    const button = event.currentTarget;
    const root = button.closest('dia-marina-free-gift');
    const card = button.closest('[data-dia-marina-card]');
    const selector = card && card.querySelector('[data-dia-marina-variant-select]');
    const variantId = selector && selector.value;

    if (!root || !variantId || button.disabled) return;

    button.disabled = true;
    button.querySelector('[data-dia-marina-button-text]').textContent = 'Agregando...';

    try {
      const cart = await fetchCart();
      const threshold = Number(root.dataset.threshold || 150000);

      if (!isActive(root) || getEligibleSubtotal(cart) < threshold) {
        await refresh(false);
        return;
      }

      const existingGifts = getGiftLines(cart);
      if (existingGifts.length) {
        await removeGiftLines(existingGifts);
      }

      const state = await addGiftVariant(variantId);
      renderSections(state);
      if (!state.sections) {
        await renderCartFromSections();
      }
      await refresh(false);
    } catch (error) {
      console.error(error);
      button.querySelector('[data-dia-marina-button-text]').textContent = 'No disponible';
    } finally {
      setTimeout(() => refresh(false), 250);
    }
  }

  function bindRoot(root) {
    if (root.dataset.diaMarinaReady === 'true') return;
    root.dataset.diaMarinaReady = 'true';

    root.querySelectorAll('[data-dia-marina-card]').forEach((card) => {
      setCardState(card);
    });
  }

  function getRoots() {
    return Array.from(document.querySelectorAll('dia-marina-free-gift'));
  }

  function initRoots() {
    getRoots().forEach(bindRoot);
  }

  function scheduleRefresh(enforce = true) {
    window.setTimeout(() => refresh(enforce), 80);
  }

  window.DiaMarinaFreeGift = {
    refresh,
    scheduleRefresh,
    init: initRoots
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initRoots();
      refresh();
    });
  } else {
    initRoots();
    refresh();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => scheduleRefresh());
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-dia-marina-add]');
    if (!button) return;
    onAddClick({ currentTarget: button });
  });

  document.addEventListener('change', (event) => {
    const selector = event.target.closest('[data-dia-marina-variant-select]');
    if (!selector) return;
    const card = selector.closest('[data-dia-marina-card]');
    if (card) setCardState(card);
  });

  document.addEventListener('dia-marina:cart-rendered', () => scheduleRefresh());
})();
